import { NAME } from "./constants";

export const SET_LOADING = `${NAME}/SET_LOADING`;